(() => {
  const sections = document.querySelectorAll('[data-best-sellers]');

  if (!sections.length) return;

  sections.forEach((section) => {
    const tabs = section.querySelectorAll('[data-collection-tab]');
    const panels = section.querySelectorAll('[data-collection-panel]');

    /* ----------------------------------------------------------------
       Mobile slider + dot pagination

       Each panel is its own horizontal scroller (home.css turns the grid
       into a flex row and the viewport into an overflow-x scroller on
       mobile). We light the dot for the card nearest the left edge, and a
       tap on a dot scrolls that card into view. On desktop the dots are
       hidden and the viewport doesn't scroll, so this is inert there.
    ---------------------------------------------------------------- */
    const wireSlider = (panel) => {
      const viewport = panel.querySelector('[data-best-sellers-viewport]');
      const grid = panel.querySelector('[data-product-grid]');
      const dotsWrap = panel.querySelector('[data-slider-dots]');
      if (!viewport || !grid) return null;

      const cards = [...grid.children];
      const dots = dotsWrap ? [...dotsWrap.querySelectorAll('i')] : [];
      if (cards.length < 2) return null;

      // Distance between two adjacent cards, measured live (it is 0 while
      // the panel is hidden, so always read it at event time).
      const step = () => {
        const a = cards[0].getBoundingClientRect();
        const b = cards[1].getBoundingClientRect();
        const s = b.left - a.left;
        return s > 0 ? s : (viewport.clientWidth || 1);
      };

      const setActive = (index) => {
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      // Dots follow the positions the strip can actually stop at. With several
      // cards in view that is fewer than the cards, so the spare dots are hidden
      // and the last dot lights up when the strip is scrolled to its end.
      const stops = () => {
        const max = viewport.scrollWidth - viewport.clientWidth;
        if (max <= 2) return 1;
        // Rounded up: a final, shorter step to the end is still a position.
        return Math.min(dots.length, Math.ceil(max / step() - 0.05) + 1);
      };

      const layoutDots = () => {
        const count = stops();
        dots.forEach((dot, i) => {
          dot.style.display = count > 1 && i < count ? '' : 'none';
        });
        return count;
      };

      const activeIndex = () => {
        const count = layoutDots();
        const max = viewport.scrollWidth - viewport.clientWidth;
        if (max > 2 && viewport.scrollLeft >= max - 2) return count - 1;
        return Math.min(count - 1, Math.max(0, Math.round(viewport.scrollLeft / step())));
      };

      const sync = () => {
        if (!dots.length) return;
        setActive(activeIndex());
      };

      window.addEventListener('resize', sync);

      let frame = 0;
      viewport.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          sync();
        });
      }, { passive: true });

      dots.forEach((dot, i) => {
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', () => {
          setActive(i); // reflect immediately; the scroll listener keeps it in sync on swipe
          viewport.scrollTo({ left: i * step(), behavior: 'smooth' });
        });
      });

      sync();
      return sync;
    };

    const syncers = new Map();
    panels.forEach((panel) => {
      syncers.set(panel.dataset.collectionPanel, wireSlider(panel));
    });

    if (!tabs.length || !panels.length) return;

    const activate = (tab) => {
      const targetId = tab.dataset.collectionTab;

      tabs.forEach((item) => {
        const active = item === tab;

        item.classList.toggle('is-active', active);
        item.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );
      });

      panels.forEach((panel) => {
        const active =
          panel.dataset.collectionPanel === targetId;

        panel.hidden = !active;
        panel.classList.toggle('is-hidden', !active);
      });

      // The freshly shown panel now has real layout metrics — refresh its dot.
      const sync = syncers.get(targetId);
      if (typeof sync === 'function') requestAnimationFrame(sync);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activate(tab);
      });
    });
  });
})();
